
import Vue from "vue";

const END_POINT = "/account";


const getAccountRoles = async () => {
    return await Vue.axios.get(END_POINT + "/get-roles")
        .then((resp) => {
            return resp.data;
        })
}


export { getAccountRoles }